// parse out just the options we care about so we always get a consistent
// obj with keys in a consistent order.
var opts = ['includePrerelease', 'loose', 'rtl'];
var parseOptions = function parseOptions(options) {
  return !options ? {} : typeof options !== 'object' ? {
    loose: true
  } : opts.filter(function (k) {
    return options[k];
  }).reduce(function (options, k) {
    options[k] = true;
    return options;
  }, {});
};
module.exports = parseOptions;